module.exports = __webpack_public_path__ + "img/light-switch-off.c81237f7.svg";